import {
    ReviewLockType,
    ReviewPresenceEventEnum,
    ReviewPresenceLockPublicationType,
    ReviewRealtimeLockMapType,
} from './review-realtime-presence-type';

export function applyReviewPresencePublication(
    locks: ReviewRealtimeLockMapType,
    publication: ReviewPresenceLockPublicationType
): ReviewRealtimeLockMapType {
    const {reviewId, brandId, userId, sessionId, action, event, timestamp} = publication;

    if (event === ReviewPresenceEventEnum.Unlock) {
        const existingLock = locks[reviewId];

        if (
            existingLock?.userId === userId &&
            existingLock?.sessionId === sessionId &&
            existingLock?.action === action
        ) {
            const {[reviewId]: removedLock, ...restLocks} = locks;

            return restLocks;
        }

        return locks;
    }

    return {
        ...locks,
        [reviewId]: {
            reviewId,
            brandId,
            userId,
            sessionId,
            action,
            lastSeenAt: timestamp,
        },
    };
}

export function removeExpiredReviewLocks(
    locks: ReviewRealtimeLockMapType,
    now: number,
    ttlMs: number
): ReviewRealtimeLockMapType {
    const activeEntries = Object.entries(locks).filter(([, lock]) => now - lock.lastSeenAt < ttlMs);

    return Object.fromEntries(activeEntries);
}

export function getReviewLock(locks: ReviewRealtimeLockMapType, reviewId: number): ReviewLockType | null {
    return locks[reviewId] ?? null;
}

export function isReviewLockedByOther(
    locks: ReviewRealtimeLockMapType,
    reviewId: number,
    userId: number,
    sessionId: string
): boolean {
    const lock = locks[reviewId];

    return Boolean(lock && !(lock.userId === userId && lock.sessionId === sessionId));
}
